import MenuItem from '@material-ui/core/MenuItem';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente MeasureMenu
 */
export const MeasureMenu = styled(MenuItem)`
  .MuiPaper-root {
    display: none;
    position: fixed;
  }

  &:hover {
    .MuiPaper-root {
      display: block;
    }
  }
`;

/**
 * Estilização do componente MeasureItem
 */
export const MeasureItem = styled(MenuItem)`
  font-size: 14px;

  svg {
    color: #3c71dd;
    position: absolute;
    left: 10px;
  }

  &.MuiMenuItem-gutters {
    padding: 6px 30px 6px 36px;
  }
`;

export const LabelMenu = MeasureMenu;
export const LabelItem = MeasureItem;
